import React, { FC, useEffect, useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { unreadNotificationsCountTemplate } from 'apollo/templates/notification/query.graphql';
import { useLazyQuery } from '@apollo/client/react';
import { useNavigate } from 'react-router-dom';

const Notifications: FC = () => {
    const [unreadCount, setUnreadCount] = useState(0);
    const navigate = useNavigate();

    const [getUnreadNotificationsCount] = useLazyQuery(unreadNotificationsCountTemplate, {
        fetchPolicy: 'network-only',
        pollInterval: 5 * 60 * 1000,
        onCompleted: ({ unreadNotificationsCount }) => {
            setUnreadCount(unreadNotificationsCount);
        },
    });
    // We are getting Bad Gateway, add the error handler when the Bad Gateway error have been fixed...
    //showBoundary(error);

    useEffect(() => {
        getUnreadNotificationsCount();
    }, []);

    // DD-3807: order details posts this after marking an order's notifications as read. The only
    // listener for it used to live in notifications-popover.component.tsx, which is never mounted,
    // so the badge kept showing the pre-read count until the next poll.
    useEffect(() => {
        const handleRefreshNotifications = (event: MessageEvent) => {
            if (event.origin !== window.location.origin) return;
            if (event.data?.eventType === 'refresh-notifications') {
                getUnreadNotificationsCount();
            }
        };
        window.addEventListener('message', handleRefreshNotifications);
        return () => window.removeEventListener('message', handleRefreshNotifications);
    }, []);

    const handleNotificationsClick = () => {
        getUnreadNotificationsCount();
        navigate('/notifications');
    };

    return (
        <IconButton
            onClick={handleNotificationsClick}
            sx={{ color: '#fff' }}
            size="large"
            className="wl-text"
            data-test="main-app-bar.notifications-btn"
        >
            <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
            </Badge>
        </IconButton>
    );
};

export default Notifications;
